import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';

import Actions_Wind from '~/Actions_Wind';
import LoadingOverlay from '~/components/LoadingOverlay';
import { S_Btn_Search, S_Select, S_Title } from '~/components/SearchItem';
import { T_TableRow, T_TitleCell } from '~/components/TableItem';

const styles = (theme) => ({
    root: {},
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300,
    },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 8 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const RenderTableTitle = (props) => {
    const { sort, sort_column_name, onChange } = props;
    const [ary, setAry] = useState([
        { name: '工作種類', id: 'job', order: false }, // true: 'desc', false: 'asc'
        { name: '船名', id: 'ship_name', order: true },
        { name: '使用風場', id: 'windfield_simplename', order: true },
        { name: '船舶許可期間', id: 'license_period_list', order: true },
        { name: '預定使用期間', id: 'scheduled_period_list', order: true },
        { name: '實際抵台時間', id: 'actural_taiwan_date', order: true },
        { name: '是否抵台', id: 'arrive_in_tw', order: true },
    ]);

    const onChangeSort = (target) => {
        let method = 'asc';
        const updatedItems = ary.map((item) => {
            if (item.id === target) {
                method = !item.order ? 'desc' : 'asc';
                return { ...item, order: !item.order };
            }
            return { ...item, order: true };
        });

        setAry(updatedItems);
        onChange(target, method);
    };

    return (
        <TableHead>
            <TableRow style={{ height: 48 }}>
                {ary.map((o, i) => (
                    <T_TitleCell
                        key={i}
                        text={o.name}
                        arrow={!!o.id}
                        bol={o.order}
                        onClick={() => onChangeSort(o.id)}
                    />
                ))}
            </TableRow>
        </TableHead>
    );
};

const RenderTableBody = (props) => {
    const { list } = props;
    const cellStyle = { fontSize: 14 };

  return (
        <TableBody>
            {list.map((o, i) => (
                <T_TableRow key={i} backgroundColor={i % 2 === 0 ? '#E0FDFF' : 'white'}>
                    <TableCell align='center' style={cellStyle}>
                        {o.job}
                    </TableCell>
                    <TableCell align='center' style={cellStyle}>
                        {o.ship_name}
                    </TableCell>
                    <TableCell align='center' style={cellStyle}>
                        {o.windfield_simplename}
                    </TableCell>
                    <TableCell align='center' style={cellStyle}>
                        {o.license_period_list}
                    </TableCell>
                    <TableCell align='center' style={{ ...cellStyle, backgroundColor: o.overlap_color }}>
                        {o.scheduled_period_list}
                    </TableCell>
                    <TableCell align='center' style={cellStyle}>
                        {o.actural_taiwan_date}
                    </TableCell>
                    <TableCell align='center' style={cellStyle}>
                        {o.arrive_in_tw}
                    </TableCell>
                </T_TableRow>
            ))}
        </TableBody>
  );
};

const RenderEmptyTableBody = (props) => {
    const { length } = props;
    const cellStyle = { fontSize: 14 };
    return (
        <TableBody>
            <T_TableRow key={'empty'} backgroundColor={'white'}>
                    <TableCell align='center' style={cellStyle} colSpan={length}>
                        {'無資料'}
                    </TableCell>
                    
                </T_TableRow>
        </TableBody>
    );
};

const SimpleSortableTable = (props) => {
    const { t, classes } = props;
    const dispatch = useDispatch();
    const ships = useSelector(state => state.data.AllFieldsShipNameList || []);
    const jobs = useSelector(state => state.data.AllFieldsJobs || []);
  
    const [isLoading, setLoading] = useState(false);
    const [windsBoatList, setWindsBoatList] = useState([]);
    const [searchCriteria, setSearchCriteria] = useState({
            selectedJobs: [],
            selectedShips: [],
            sortConfig: {
                sort_column_name: '',
                sort_method: '',
            },
    });


    const onClickSearch = () => {
        setLoading(true);

        if (searchCriteria.selectedJobs.length == 0 || searchCriteria.selectedShips.length == 0) {
            setLoading(false);
        } else {
            Actions_Wind.Gis.getWindsBoatListV3({
                body: { job_types: searchCriteria.selectedJobs, ship_names: searchCriteria.selectedShips, ...searchCriteria.sortConfig },
            }).then(res => {
                console.log(res);
                setWindsBoatList(res);
    
                setLoading(false);
            });
        }
    };

    const haveData = windsBoatList.length > 0;
    
    useEffect(() => {
        Actions_Wind.Gis.getAllFieldsShipNameList(dispatch);
        Actions_Wind.Gis.getAllFieldsJobs(dispatch);
    }, []);

    useEffect(() => {
        if (jobs.length > 0 && ships.length > 0) {
            setSearchCriteria((prevSearchCriteria) => ({
                ...prevSearchCriteria,
                selectedJobs: jobs,
                selectedShips: ships,
                sortConfig: {
                    sort_column_name: 'job',
                    sort_method: 'asc',
                },
            }));
        }
    }, [ships, jobs]);

    useEffect(() => {
        onClickSearch();
    }, [searchCriteria.sortConfig]);

    const handleChangeJob = (e) => {
        setSearchCriteria((prevSearchCriteria) => ({
            ...prevSearchCriteria,
            selectedJobs: e.target.value,
        }));
    };

    const handleChangeShip = (e) => {
        setSearchCriteria((prevSearchCriteria) => ({
            ...prevSearchCriteria,
            selectedShips: e.target.value,
        }));
    };

    const handleSort = (column) => {
        setSearchCriteria((prevSearchCriteria) => {
            const { sortConfig } = prevSearchCriteria;
            const newSortMethod = sortConfig.sort_column_name === column ? (sortConfig.sort_method === 'asc' ? 'desc' : 'asc') : 'asc';

            return {
                ...prevSearchCriteria,
                sortConfig: { sort_column_name: column, sort_method: newSortMethod },
            };
        });
    };

    return (
        <>
            {isLoading && <LoadingOverlay loading={isLoading} />}
            <div style={{ display: 'flex', padding: 20 }}>
                <div>
                    <FormControl variant='outlined' className={classes.formControl}>
                        {/* <InputLabel id='job-select-label'>工作種類</InputLabel> */}
                        <S_Title text='工作種類' />
                        <Select
                            labelId='job-select-label'
                            id='job-select'
                            multiple
                            value={searchCriteria.selectedJobs}
                            onChange={handleChangeJob}
                            renderValue={(selected) => selected.join(', ')}
                            MenuProps={MenuProps}
                        >
                            {jobs.map((job) => (
                                <MenuItem key={job} value={job}>
                                    <Checkbox checked={searchCriteria.selectedJobs.indexOf(job) > -1} />
                                    <ListItemText primary={job} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
                <div>
                    <FormControl variant='outlined' className={classes.formControl}>
                        {/* <InputLabel id='ship-select-label'>船名</InputLabel> */}
                        <S_Title text='船名' />
                        <Select
                            labelId='ship-select-label'
                            id='ship-select'
                            multiple
                            value={searchCriteria.selectedShips}
                            onChange={handleChangeShip}
                            renderValue={(selected) => selected.join(', ')}
                            MenuProps={MenuProps}
                        >
                            {ships.map((ship) => (
                                <MenuItem key={ship} value={ship}>
                                    <Checkbox checked={searchCriteria.selectedShips.indexOf(ship) > -1} />
                                    <ListItemText primary={ship} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
                <div style={{ marginLeft: 16, display: 'flex', flexDirection: 'column-reverse' }}>
                    <S_Btn_Search onClick={onClickSearch} />
                </div>
            </div>

            <TableContainer>
                <Table style={{ backgroundColor: 'white', borderRadius: 8 }}>
                    <RenderTableTitle
                        sort_column_name={searchCriteria.sortConfig.sort_column_name}
                        sort={searchCriteria.sortConfig.sort_method === 'desc'}
                        onChange={handleSort}
                    />
                    {haveData && <RenderTableBody list={windsBoatList} />}
                    {!haveData && <RenderEmptyTableBody length={7} />}
                </Table>
            </TableContainer>
        </>
    );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(SimpleSortableTable);